import Vue from "vue";
import SharedGenericGalleryListing from "./SharedGenericGalleryListing.vue";

export function load() {
  const selector = "shared-gallery-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(SharedGenericGalleryListing, {
        props: {
          ...window[selector]
        }
      })
  }).$mount(selector);
}
